import {FormGroup, NG_VALIDATORS, ValidationErrors, Validator} from "@angular/forms";
import {Directive, Input} from "@angular/core";
import {PasswordMatchValidator} from "./password-match-validator";

@Directive({
    // tslint:disable-next-line:directive-selector
    selector: '[passwordMatchValidator]',
    providers: [{ provide: NG_VALIDATORS, useExisting: PasswordMatchValidatorDirective, multi: true }]
})
export class PasswordMatchValidatorDirective implements Validator {

    constructor() { }

    @Input('passwordMatchValidator') passwordMatchValidator: any[] = [];

    validate(formGroup: FormGroup): ValidationErrors {
        return PasswordMatchValidator(
            this.passwordMatchValidator[0],
            this.passwordMatchValidator[1],
            this.passwordMatchValidator[2],
            this.passwordMatchValidator[3])(formGroup);
    }
}
